import { RepositoryFactory } from '../data/RepositoryFactory'
import { isSuccessful } from '../data/OHMRepository'

const OHMRepository = RepositoryFactory.get('ohm')

export const articleModule = {
  namespaced: true,
  state: () => ({
    latestArticles: [],
    selected: null,
  }),
  mutations: {
    setLatest(state, articles) {
      state.latestArticles = articles
    },
    setSelected(state, article) {
      state.selected = article
    },
  },
  actions: {
    getLatest({ commit, state, rootState }, id_link) {
      return new Promise((resolve, reject) => {
        if (state.latestArticles.length) {
          return resolve()
        }
        OHMRepository.getLatest(rootState.id_site, id_link)
        .then((response) => {
          if (isSuccessful(response) && response.data.latest) {
            commit('setLatest', response.data.latest)
            commit('setSelected', response.data.latest[0])
            return resolve()
          }
          return reject(response)
        })
      }).catch((error) => {
        reject(error)
      })
    }
  }
}
